module.exports = __webpack_public_path__ + "img/orange-stacked.2999bbdd.png";